import React from 'react'
import PageTitle from '../layouts/PageTitle'
import OrderWrap from '../payment/OrderWrap'
import OrderItem from '../payment/OrderItem'
import OrderRow from '../payment/OrderRow'
import PaymentMethods from '../payment/PaymentMethods'
import { AdOrderContext } from '../../contexts/AdOrder'
import Input from '../inputs/Input'
import PaymentMethod from '../payment/PaymentMethod'
import InputWrap from '../inputs/InputWrap'
import CheckboxInput from '../inputs/CheckboxInput'
import useGoToPayment from '../../hooks/useGoToPayment'

export default function Payment () {
  const { adOrder } = React.useContext(AdOrderContext)
  const { submit } = useGoToPayment()

  const setDate = dateString => {
    return dateString.split(' ')[0]
  }

  const setTime = dateString => {
    const timeWithSeconds = dateString.split(' ')[1]
    return `${timeWithSeconds.split(':')[0]}:${timeWithSeconds.split(':')[1]}`
  }

  return (
    <>
      <PageTitle step={2}/>

      <OrderWrap>
        <OrderRow>
          <OrderItem title={'Overskrift på annoncen'}>
            {adOrder.headline}
          </OrderItem>
        </OrderRow>
        <OrderRow>
          <OrderItem title={'Dato'} size={'third'}>
            {setDate(adOrder.date)}
          </OrderItem>
          <OrderItem title={'Klokkeslæt'} size={'third'}>
            {setTime(adOrder.date)}
          </OrderItem>
          <OrderItem title={'Sted'} size={'third'}>
            {adOrder.location}
          </OrderItem>
        </OrderRow>
        <OrderRow>
          <OrderItem title={'Link til hjemmesiden'}>
            {adOrder.url}
          </OrderItem>
        </OrderRow>
        <OrderRow>
          <OrderItem title={'Tekst til annoncen og evt. øvrige bemærkninger'}>
            {adOrder.content}
          </OrderItem>
        </OrderRow>
        <OrderRow>
          <OrderItem title={'Billede til annoncen'}>
            <img src={adOrder.image} alt={'dit oploadede billede'}/>
          </OrderItem>
        </OrderRow>
      </OrderWrap>

      <PaymentMethods title={'Vælg betalingsmetode'}>
        <PaymentMethod
            value={'dibs'}
            label={'Betalingskort eller Mobilepay'}
            description={'Vi tager imod en bred vifte af betalingskort; Dankort/VISA-Dankort, MasterCard, Maestro, Visa, Visa Electron'}
        />
        <PaymentMethod value={'ean'} label={'Faktura'} description={'Til offentlige kunder fremsendes fakturaen elektronisk via EAN-nummer.'}>
          <Input name={'ean'} placeholder={'Indtast EAN-nr'} subobj={'payment'} pattern={'/\d{13}/'}/>
        </PaymentMethod>
      </PaymentMethods>
      <div className={'ad-next-step between spacing'}>
        <CheckboxInput
            label={'Jeg accepterer handelsbetingelser'}
            value={true}
            name={'accept'}
            subobj={'payment'}/>
        <button onClick={submit} className={'button secondary'}>Betal annoncen</button>
      </div>
    </>
  )
}
